export function buildWhatsappMessage({ nombre, apellido, personas }) {
  return (
    `¡Hola Panache! Quiero consultar por un evento.\n` +
    `Nombre: ${nombre} ${apellido}\n` +
    `Cantidad de personas: ${personas}`
  );
}

export function buildWhatsappUrl(data, number) {
  const message = buildWhatsappMessage(data);
  return `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
}

export function validateEventoForm({ nombre, apellido, personas }) {
  if (!nombre?.trim()) return 'Por favor completá tu nombre.';
  if (!apellido?.trim()) return 'Por favor completá tu apellido.';

  const parsed = Number(personas);
  if (Number.isNaN(parsed)) return 'La cantidad de personas debe ser un número.';
  if (parsed <= 0) return 'La cantidad de personas debe ser al menos 1.';
  if (!Number.isInteger(parsed)) return 'La cantidad de personas debe ser un número entero.';

  return null;
}
